<template>
  <div>
    <AdminNavbar />
    <div class="container mt-3">
      <DebugEnv />
    </div>
  </div>
</template>

<script>
import AdminNavbar from "@/admin/components/AdminNavbar";
import DebugEnv from "@/components/debug/DebugEnv";

export default {
  name: "SettingsView",
  components: {
    AdminNavbar,
    DebugEnv
  }
};
</script>
